<template>
  <b-field
    custom-class="has-text-grid-1 is-size-14px has-text-weight-bold"
    :label="$t('pointDeVente.titleLabel')">
    <b-autocomplete
      v-model="valuePdv"
      @select="onSelect"
      :data="filteredDataPdv"
      :clearable="true"
      :loading="isLoaded"
      :placeholder="$t('pointDeVente.placeholder')"
      field="nomCommercial"
      icon="magnify"
      open-on-focus>
      <template slot-scope="props">
        <p class="has-text-weight-bold">
          {{ props.option.nomCommercial }}
          <br>
          <small class="has-text-weight-normal">
            {{ props.option.adresse }}
          </small>
        </p>
      </template>
      <template #empty>{{ lebelEmpty }}</template>
    </b-autocomplete>
  </b-field>
</template>

<script>
import { browseClients } from '@/api/clients/index';
import { POINT_VENTE, WITHOUT_LOGO, SOUS_TYPE_AUCUN, TYPE_CLIENT } from '@/configuration/clientConf';
import gestionErreur from '@/services/general/gestionErreur';

export default {
  name: 'SelecteurPointDeVente',
  props: {
    societeId: {
      type: [String, Number],
      default: null,
    },
    valeurInitiale: {
      type: String,
      default: '',
    },
    idsExclus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      listePdv: [],
      valuePdv: '',
      isLoaded: false,
    };
  },
  computed: {
    filteredDataPdv() {
      return this.listePdv.filter((option) => {
        if (this.idsExclus.includes(option.id)) return false;
        return option.nomCommercial
          .toString()
          .toLowerCase()
          .indexOf(this.valuePdv.toLowerCase()) >= 0;
      });
    },
    lebelEmpty() {
      return [this.$t('pointDeVente.notFoundResult'), this.valuePdv].filter(Boolean).join(' ');
    },
  },
  methods: {
    onSelect(client) {
      this.$emit('select', client);
    },
    async getListePdv() {
      this.isLoaded = true;
      try {
        const query = {
          sousType: SOUS_TYPE_AUCUN,
          type: TYPE_CLIENT,
          typologie: POINT_VENTE,
          societeId: this.societeId,
          avecAdresse: true,
          avecCoordonnees: true,
        };
        this.listePdv = (await browseClients(WITHOUT_LOGO, query)).data;
      } catch (error) {
        gestionErreur('Erreur lors de la récupération des clients de type point de vente', error);
        throw error;
      } finally {
        this.isLoaded = false;
      }
    },
  },
  async mounted() {
    this.valuePdv = this.valeurInitiale || '';
    await this.getListePdv();
  },
};
</script>
